import Swal from 'sweetalert2';
import consts from '../consts';
import strings from '../globalization';
import { util } from 'prettier';

const utility = {
  /**
   * @desc Convert combo values to comma seperated string based on "value"
   * @param {Object} values - Object/data that need to be proccessed/save
   * @param {Array} comboFields - String Array of combo fields
   */
  processDataBeforeSave: (values, comboFields) => {
    let toReturn = { ...values };
    if (!comboFields || comboFields.length === 0) {
      return toReturn;
    }
    for (let comboTypes of comboFields) {
      let { name, isArray } = comboTypes;
      let value = toReturn[name];
      if (typeof value === 'string') {
        if (isArray && !value) {
          toReturn[name] = [];
        }
        continue;
      }

      if (!Array.isArray(value) && value) {
        toReturn[name] = value.value;
      } else {
        toReturn[name] =
          value &&
          value.map(obj => (typeof obj === 'string' ? obj : obj.value));
      }
    }
    return toReturn;
  },
  /**
   * @desc Convert remote combo object to 'value' 'label' object supported by react-select
   * @param {Object} config - Is a object of "valueProp" and "displayValue"
   * @param {Object} store - Combo Store that need to be proccessed
   * @param {Array} disableValues - Optional - String Array of disable values which work on "valueProp"
   */
  remoteComboLoader: (config, store, disableValues = [], comboFields) => {
    if (!store || !Array.isArray(store)) {
      return null;
    }
    return store.map(obj => {
      let value = obj[config.valueProp];
      return {
        value: value,
        label: obj[config.displayValue],
        isDisabled: disableValues.includes(value)
      };
    });
  },
  applicationBody: isDark => {
    if (isDark) {
      document.body.classList.add('dark_body');
    } else {
      document.body.classList.remove('dark_body');
    }
  },
  cloneArrayOfObject: sourceArr => {
    let toReturn = [];
    for (var i = 0, len = sourceArr.length; i < len; i++) {
      toReturn[i] = {}; // empty object to hold properties added below
      for (var prop in sourceArr[i]) {
        toReturn[i][prop] = sourceArr[i][prop]; // copy properties from arObj to ar2
      }
    }
    return toReturn;
  },
  onLicenseDownload: (id, licenseData, showMessage) => {
    const {
      Facility,
      facility,
      MachineKey,
      ExpirationDate,
      CatSoftwareVersion
    } = licenseData;
    const {
      CountryCode,
      State,
      City,
      Name,
      OrganizationalUnit,
      EmailAddress,
      CommonName,
      TimeZone
    } = facility || Facility;
    if (!MachineKey || !ExpirationDate) {
      Swal.fire({
        title: `Please enter ${
          !MachineKey && !ExpirationDate
            ? 'MachineKey & Expiration date'
            : !MachineKey
            ? 'MachineKey'
            : 'Expiration date'
        } to download license`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      });
      return;
    }
    if (!CatSoftwareVersion) {
      Swal.fire({
        title: `Please provide CAT Software Version on the License Details form`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      });
      return;
    }
    if (!TimeZone) {
      Swal.fire({
        title: `Please select Time Zone on the facility form.`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      });
      return;
    }
    if (!CountryCode && !State && !City) {
      Swal.fire({
        title: strings.downloadMessage,
        icon: 'info'
      });
      return;
    }
    const isCsrCreatable =
        CountryCode &&
        State &&
        City &&
        Name &&
        OrganizationalUnit &&
        EmailAddress &&
        CommonName,
      details = [];
    if (!CountryCode) {
      details.push('Country');
    }
    if (!State) {
      details.push('State');
    }
    if (!City) {
      details.push('City');
    }
    if (!OrganizationalUnit) {
      details.push('Organizational Unit');
    }
    if (!EmailAddress) {
      details.push('Email Address');
    }
    if (!Name) {
      details.push('Site Name');
    }
    if (!CommonName) {
      details.push('Common Name');
    }
    const isCatSync = licenseData.ProductTypeName.indexOf('CAT Sync') !== -1;
    if (!isCatSync || (isCatSync && isCsrCreatable)) {
      window.open(`${consts.hostURL}/downloadlicense?_id=${id}`, '_blank');
    } else {
      if (!showMessage) {
        Swal.fire({
          title: 'Are you sure?',
          html: `<b style="font-weight: 500">Certificate will not be generated for this license</b>
            <br/>
            To generate Please enter following details in the facility
            ${details.join(',')}`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(result => {
          if (result.value) {
            window.open(
              `${consts.hostURL}/downloadlicense?_id=${id}`,
              '_blank'
            );
          }
        });
      }
      if (showMessage !== undefined) {
        window.open(`${consts.hostURL}/downloadlicense?_id=${id}`, '_blank');
      }
    }
  },
  onDownloadCertificate: (row, isFromGrid = false) => {
    const url = new URL(`${consts.hostURL}/download`);
    url.searchParams.append('LicenseId', row._id);
    url.searchParams.append('Type', 'Server');
    url.searchParams.append('ClientCommonName', row.Facility.CommonName);
    url.searchParams.append('IsServer', true);
    url.searchParams.append('isFromGrid', isFromGrid);
    url.toString();
    window.open(url, '_blank');
  }
};

export default utility;
